import { setupTranslations } from '@aftersale-next/translations';
var i18nInstance = setupTranslations();
export default i18nInstance;